// 数据缓存，可以用于一切key、value键值对缓存
// TODO，本地持久化缓存，以及指定时间缓存

// 数据合并方法
var extendMethods = {
  // 引用替换，默认
  quoteReplace(newData, oldData) {
    return newData
  },
  // 浅层合并
  shallowReplace(newData, oldData) {
    if (newData instanceof Array) {
      return [...oldData, ...newData]
    }
    return {
      ...oldData,
      ...newData
    }
  },
  // 深层合并
  deepReplace(newData, oldData) {
    return {
      ...oldData,
      ...newData
    }
  }
}
export default {
  namespaced: true,
  state: {
    cacheSpace: {}
  },
  mutations: {
    SET_CACHEDATA(state, payload) {
      const { cacheSpace } = state
      const { key, data, extendMethod = 'quoteReplace' } = payload
      const fn = typeof extendMethod === 'function' ? extendMethod : extendMethods[extendMethod]
      state.cacheSpace[key] = fn(data, cacheSpace)
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {},
  getters: {
    getData: (state) => (key) => state.cacheSpace[key]
  }
}
